import { sanitizeString } from '@/support/String';
import Question from '@/views/Questionnaire/Question';
import { Questions } from '@/views/Questionnaire/questions';
import { DateTime } from 'luxon';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component<QuizAnswers>({
  components: {
    Question,
  },
  filters: {
    formatString(text: string) {
      return text.replace('_', ' ');
    },
    formatBoolean(value: boolean) {
      if (value === true) {
        return 'Leuk';
      } else {
        return 'Niet leuk';
      }
    },
    formatTimeSeconds(time: string) {
      if (!time) {
        return;
      }
      return time.slice(0, -3);
    },

    formatBirthday(date: string) {
      if (!date) {
        return '';
      }

      const birthday = DateTime.fromFormat(date, 'yyyy-LL-dd');
      if (!birthday.isValid) {
        return date;
      }

      const now = DateTime.local();
      return Math.floor(Math.abs(birthday.diff(now, 'years').toObject().years || 0));
    },

    formatPhone(phone: string) {
      if (!phone) {
        return '-';
      }

      if (phone.substr(0, 4) === '0031') {
        return phone.substr(4, phone.length - 1);
      }
      return phone;
    },

    formatCurrency(value: string) {
      if (!value) return '';
      return String(value)
        .replace(/\\u20ac/gi, '')
        .replace(/\\u00a0/g, '')
        .replace(/[€$\u00a0\u20ac]/g, '')
        .trim();
    },
  },
})
export default class QuizAnswers extends Vue {
  @Prop({ default: () => [] })
  protected userAnswers: any;

  @Prop({ default: () => [] })
  protected user: any;

  @Prop({ default: () => [] })
  protected userImages: any;

  @Prop()
  protected model!: string;

  protected webshop: boolean = false;
  protected userAnswersClone: any;
  protected userImagesClone: any[] = [];
  protected answers: any = {
    stijl: [],
    figuur: [],
    voorkeur: [],
    over_jou: [],
    mijn_fotos: [],
    box: [],
  };

  protected webshopKeys: any[] = [
    'input-rows_2',
    'upload-file_1',
    'checkbox-list_1',
    'checkbox-list_5',
    'checkbox-list_6',
    'checkbox-list_7',
    'radio-list-boxes_4',
    'textarea_1',
  ];

  protected webshopAnswers: any[] = [];

  protected categories: Categories[] = [
    {
      key: 'stijl',
      label: this.$tc('contactsPage.quizView.style'),
    },
    {
      key: 'figuur',
      label: this.$tc('contactsPage.quizView.bodyType'),
    },
    {
      key: 'voorkeur',
      label: this.$tc('contactsPage.quizView.preferences'),
    },
    {
      key: 'mijn_fotos',
      label: this.$tc('contactsPage.quizView.myFotos'),
    },
    {
      key: 'box',
      label: this.$tc('contactsPage.quizView.box'),
    },
  ];

  protected editAnswerDialog: boolean = false;
  protected currentQuestion: object = {};
  protected currentAnswer: any = undefined;

  public mounted() {
    if (this.userAnswers) {
      this.parseAnswers(this.userAnswers);
    }
    if (
      this.$route.name === 'webshop' ||
      this.$route.name === 'webshop.order' ||
      this.$route.name === 'webshop.order.detail'
    ) {
      this.webshop = true;
      if (this.userAnswers) {
        this.mapWebshopAnswers();
      }
    }
  }

  protected santizeString(value: string) {
    if (!value) {
      return '';
    }

    return sanitizeString(value);
  }

  protected mapWebshopAnswers() {
    if (!this.webshopKeys || !this.userAnswers) {
      return;
    }
    this.webshopKeys.forEach((key: any) => {
      this.userAnswers.forEach((answer: any) => {
        if (answer.key === key) {
          this.webshopAnswers.push(answer);
        }
      });
    });
  }

  protected mapAnswers(answers: any) {
    if (!answers) {
      return;
    }
    answers.forEach((answer: any) => {
      //Check if the answer contains the original question, this was not the case earlier in development.
      //That's why if there is no question in the answer, the current question with the same key as the answer is fetched
      // if (!answer.question) {
      const question = Questions.find((question: any) => {
        return question.key === answer.key;
      });

      if (!question) {
        return;
      }

      answer['question'] = question;
      answer['category'] = question.category;
      // }
    });
    this.parseAnswers(answers);
  }

  protected parseAnswers(answers: any) {
    if (!answers) {
      return;
    }
    this.answers['mijn_fotos'] = [];
    answers.forEach((answer: any) => {
      if (this.answers[answer.category]) {
        for (let i = 0; i < this.answers[answer.category].length; i++) {
          if (this.answers[answer.category][i].key === answer.key) {
            this.answers[answer.category][i] = answer;
            return;
          }
        }
        this.answers[answer.category].push(answer);
      }
    });
  }

  protected mapFigure(figure: string) {
    const figureIndex: any = figure.substr(figure.length - 1);
    return figureIndex;
  }

  protected parseAnswerString(answer: string) {
    return answer.replace(' ', '_').toLowerCase();
  }

  protected parseAnswerBoolean(answer: boolean) {
    return answer.toString();
  }

  private setSingleAnswers(answer: any) {
    if (!this.userAnswersClone || !this.userAnswersClone.length) {
      return;
    }

    const index = this.userAnswersClone.findIndex((element: any) => {
      return element.key === answer.key;
    });

    if (index >= 0) {
      this.userAnswersClone[index].value = answer.value;
    }
    this.$emit('handleAnswerUpdate', this.userAnswersClone);
    this.editAnswerDialog = false;
  }

  setImages(answer: any) {
    if (!this.userAnswersClone || !this.userAnswersClone.length) {
      return;
    }
    const images: any[] = [];
    answer.value.forEach((image: any) => {
      images.push(image);
    });
    this.$emit('handleImageUpdate', images);
    this.editAnswerDialog = false;
  }

  protected setAnswer(answer: any) {
    if (answer.type === 'upload-file') {
      this.setImages(answer);
    } else {
      this.setSingleAnswers(answer);
    }
  }

  protected handleQuestionAnswer(answer: any) {
    this.setAnswer(answer);

    // clear prop currentAnswer after editing
    this.currentAnswer = undefined;
  }

  protected deleteImage(index: number) {
    this.$emit('handleImageDelete', this.answers.mijn_fotos[index].id);
    this.answers.mijn_fotos.splice(index, 1);
  }

  protected closeDialog() {
    if (this.editAnswerDialog) {
      this.editAnswerDialog = false;
    }
  }

  protected editAnswer(answer: any) {
    this.currentQuestion = answer.question;
    this.currentAnswer = answer;

    if (answer.key === 'radio-list-boxes_4' || answer.key === 'checkbox-list_wishlist') {
      this.currentAnswer.type = 'textarea';
    }

    this.editAnswerDialog = true;
  }

  protected get isExistingQuestion(): boolean {
    const result = !!Questions.find((question: any) => {
      return question.key === (this.currentQuestion as any).key;
    });

    return result;
  }

  protected uploadFiles() {
    let fileQuestion = Questions.filter(this.findFileQuestion);
    this.currentQuestion = fileQuestion[0];
    this.editAnswerDialog = true;
  }

  protected getAnswerClass(answer: any, category: any) {
    if (category.key === 'mijn_fotos') {
      return 'upload-file';
    }

    return answer.type;
  }

  protected isNewCategory(category: any, index: number) {
    const answer = this.answers[category.key][index];
    if (!answer) {
      return false;
    }

    const previousAnswer = this.answers[category.key][index - 1];
    if (!previousAnswer) {
      return false;
    }

    return this.getAnswerClass(answer, category) !== this.getAnswerClass(previousAnswer, category);
  }

  protected findFileQuestion(value: any) {
    return value.type === 'upload-file';
  }

  protected isPillChecked(anwser: any, option: any, index: number) {
    const questionKey = option.key;
    if (!anwser.value[questionKey]) {
      return false;
    }
    const value = anwser.value[questionKey].label;
    return parseInt(value) === index;
  }

  @Watch('userAnswers')
  protected userAnswersChanged(answers: string) {
    if (answers.length) {
      this.userAnswersClone = [...answers];
      this.mapAnswers(this.userAnswersClone);
      this.mapWebshopAnswers();
    }
  }

  @Watch('userImages')
  protected userImagesChanged(images: any[]) {
    if (images.length) {
      this.userImagesClone = [...images];
      this.answers['mijn_fotos'] = [...images];
    }
  }

  protected seeProfile() {
    this.$router.push({
      name: 'contacten.show',
      params: { id: this.user.id },
      query: { editing: 'true' },
    });
  }
}

interface Categories {
  key: string;
  label: string;
}
